module.exports = __webpack_public_path__ + "img/idcard1.6a36035a.png";